<template>
  <div class="container container-fluid">
    <div v-if="showComponentData">
      <!-- NUMERO DE POLIZA-->
      <div v-if="isFieldVisible('insurance_certificate_observations')" class="col-md-4 mt-3">
        <div class="col-md-8">
          <label for="insurance_certificate_observations" class="form-label text-left">{{ getFieldDescription('insurance_certificate_observations') }}</label>
          <input 
            type="text"
            class="form-control" 
            id="insurance_certificate_observations" 
            v-model="formData.insurance_certificate_observations"
            maxlength="20"
            required="required"
            @input="() => emitFieldChanged('insurance_certificate_observations')"
          />
        </div>
      </div>
      <hr class="custom-hr mt-4"/>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';

export default {
  name: 'FormInsuranceCertificateObservations',
  props: {
    data: Object,
  },
  emits: ['formDataChanged'],
  setup(props, { emit }) {
    const dataCompany = ref(props.data.dataCompaniesForms);
    const dataFormsField = ref(props.data.dataFormsField);
    const showComponentData = ref(false);

    const insurance_certificate_observations = ref(null);

    const formData = ref({
      insurance_certificate_observations: null,
    });

    const cargarDatos = () => {
      try {
        showComponentData.value = (dataCompany.value && dataCompany.value.insurance_certificate_observations);
      } catch (error) {
        console.error(error);
      }
    };

    const isFieldVisible = (fieldName) => {
      return dataCompany.value && dataCompany.value[fieldName] === 1;
    };

    const getFieldDescription = (fieldNameLabel) => {
      let description = fieldNameLabel;
      const dataFormsFieldsWithData = Object.values(dataFormsField.value);
 
      dataFormsFieldsWithData[0].forEach((entry) => {
        const field = entry;
 
        if (field.name === fieldNameLabel) {
          description = field.description;
        }
      });
      return description;
    };

    const emitFieldChanged = () => {
      emit('formDataChanged', formData.value);
    };

    onMounted(cargarDatos);

    return {
      dataCompany,
      showComponentData,
      isFieldVisible,
      getFieldDescription,
      dataFormsField,
      formData,
      emitFieldChanged,
      insurance_certificate_observations,
    };
  },
};
</script>
